import allImage from './images/all.svg';
import collectionImage from './images/collection.svg';
import deliveryImage from './images/delivery.svg';
import inTransitImage from './images/in-transit.svg';
import priorityImage from './images/priority.svg';
import recentlyDeliveredImage from './images/recently-delivered.svg';
import type { ScopeConfig } from './types';
import { ShipmentScope } from './types';

export const scopeConfigs: ScopeConfig[] = [
  { image: allImage, kpiField: 'all', label: 'All', scope: ShipmentScope.ALL },
  { image: priorityImage, kpiField: null, label: 'High priority', scope: ShipmentScope.HIGH_PRIORITY },
  { image: collectionImage, kpiField: 'collection', label: 'Collection', scope: ShipmentScope.COLLECTION },
  { image: inTransitImage, kpiField: 'inTransit', label: 'In transit', scope: ShipmentScope.IN_TRANSIT },
  { image: deliveryImage, kpiField: 'delivery', label: 'Delivery', scope: ShipmentScope.DELIVERY },
  {
    image: recentlyDeliveredImage,
    kpiField: 'recentlyDelivered',
    label: 'Recently delivered',
    scope: ShipmentScope.RECENTLY_DELIVERED
  }
];
